import type { ShopEstilosConfig } from "../types/ShopEstilosConfig";

export const LG = {
    color: {
        cream50: "#ffffff",
        cream100: "#f9f9fc",
        cream200: "#f0f1f5",
        cream300: "#e8eaf0",
        cream400: "#dde2ea",
        cream: "#f9f9fc",
        creamLight: "#ffffff",
        text: "#1a1c1e",
        ink800: "#2d3038",
        ink700: "#404751",
        textSecondary: "#404751",
        textMuted: "#707882",
        textDisabled: "#bfc7d2",
        surface: "rgba(255, 255, 255, 0.70)",
        surfaceHover: "rgba(255, 255, 255, 0.85)",
        surfaceStrong: "rgba(255, 255, 255, 0.90)",
        surfaceDark: "rgba(0, 58, 92, 0.55)",
        border: "rgba(255, 255, 255, 0.40)",
        borderStrong: "rgba(255, 255, 255, 0.60)",
        divider: "rgba(191, 199, 210, 0.50)",
        gold: "#00629c",
        goldSoft: "#cfe5ff",
        buttonDark: "#00629c",
        buttonDarkText: "#ffffff",
    },
    radius: {
        xs: "12px",
        sm: "16px",
        md: "24px",
        lg: "32px",
        xl: "40px",
        pill: "999px",
    },
    blur: "blur(20px) saturate(180%)",
    blurLight: "blur(16px) saturate(180%)",
    blurStrong: "blur(28px) saturate(200%)",
    shadow: {
        sm: "0 4px 14px -6px rgba(0,58,92,0.12), inset 0 1px 0 rgba(255,255,255,0.9)",
        md: "0 12px 40px -12px rgba(0,58,92,0.10), 0 2px 6px -2px rgba(0,58,92,0.06), inset 0 1px 0 rgba(255,255,255,0.85), inset 0 -1px 0 rgba(0,0,0,0.02)",
        lg: "0 30px 80px -24px rgba(0,58,92,0.16), 0 8px 24px -8px rgba(0,58,92,0.08), inset 0 1px 0 rgba(255,255,255,0.85), inset 0 -1px 0 rgba(0,0,0,0.02)",
        xl: "0 40px 100px -40px rgba(0,58,92,0.20), inset 0 1px 0 rgba(255,255,255,0.6)",
    },
    transition: "all 0.25s ease",
    fontFamily: '"Plus Jakarta Sans", "Manrope", system-ui, sans-serif',
};

export function hidratarLG(config: ShopEstilosConfig): void {
    const { colores: c, radios: r, blur: b, sombras: s, tipografia: t } = config;

    Object.assign(LG.color, {
        cream50: c.fondoClaro,
        cream100: c.fondo,
        cream200: c.fondoMedio,
        cream300: c.fondoCalido,
        cream400: c.fondoIntenso,
        cream: c.fondo,
        creamLight: c.fondoClaro,
        text: c.texto,
        ink800: c.textoInk800,
        ink700: c.textoInk700,
        textSecondary: c.textoSecundario,
        textMuted: c.textoMuted,
        textDisabled: c.textoDeshabilitado,
        surface: c.superficieGlass,
        surfaceHover: c.superficieHover,
        surfaceStrong: c.superficieGlassStrong,
        surfaceDark: c.superficieGlassDark,
        border: c.borde,
        borderStrong: c.bordeStrong,
        divider: c.divider,
        gold: c.gold,
        goldSoft: c.goldSoft,
        buttonDark: c.botonOscuroBg,
        buttonDarkText: c.botonOscuroTexto,
    });

    Object.assign(LG.radius, {
        xs: r.xs,
        sm: r.sm,
        md: r.md,
        lg: r.lg,
        xl: r.xl,
        pill: r.pill,
    });

    Object.assign(LG.shadow, {
        sm: s.sm,
        md: s.md,
        lg: s.lg,
        xl: s.xl,
    });

    LG.blur = b.normal;
    LG.blurLight = b.light;
    LG.blurStrong = b.strong;
    LG.fontFamily = t.fontFamily;
}

export const formatMoney = (value?: number) => {
    if (!value) return "$0";
    return `$${value.toLocaleString("es-AR", { maximumFractionDigits: 0 })}`;
};
